<template>
  <div
    :class="[
      'certification-list-item__price',
      smallTile && 'certification-list-item__price--small-tile',
    ]"
  >
    <div
      :class="[
        'certification-list-item__price-amount',
        smallTile && 'certification-list-item__price-amount--small-tile',
      ]"
    >
      <span>{{ priceToShow.units }}</span>
      <span
        v-if="priceToShow.cents"
        :class="[
          'certification-list-item__price-amount--cents',
          smallTile && 'certification-list-item__price-amount--cents-small-tile',
        ]"
        >{{ priceToShow.cents }}</span
      >
    </div>
    <span
      v-if="showDiscountBadge && certification.user_receives_discount"
      class="certification-list-item__price-no-discount"
    >
      Full price {{ priceToShow.fullPrice }}
    </span>
    <div
      v-if="showDiscountBadge && certification.user_receives_discount"
      class="certification-list-item__neon-wrapper"
    >
      <div class="certification-list-item__neon-content">
        <div class="certification-list-item__neon-text">YOU SAVE 50%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificationListItemPrice',
  props: {
    certification: {
      type: Object,
      required: true,
    },
    showDiscountBadge: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDiscountPrice: {
      type: Boolean,
      required: false,
      default: false,
    },
    smallTile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    priceToShow() {
      let newPrice
      if (this.showDiscountPrice) {
        newPrice = this.certification.user_receives_discount
          ? `$${this.certification.discounted_price_cents / 100}`
          : `$${this.certification.price_cents / 100}`
        newPrice = newPrice.split('.')
      } else {
        newPrice = this.certification.price.split('.')
      }
      return {
        fullPrice: `$${this.certification.price_cents / 100}`,
        units: newPrice[0],
        cents: newPrice[1] > 0 ? `.${newPrice[1] < 10 ? newPrice[1] * 10 : newPrice[1]}` : false,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.certification-list-item {
  &__price {
    font-weight: 700;
    font-size: 54px;
    line-height: 66px;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-right: 20px;
    padding-top: 50px;
    grid-area: 1/2/1/3;
    margin-top: 0;
    @include mobile {
      padding-top: 40px;
      justify-content: flex-end;
    }
    @include desktop {
      padding-top: 0;
      margin-top: 20px;
      justify-content: center;
    }
    position: relative;
    &--small-tile {
      padding-top: 16px;
      @include mobile {
        padding-top: 40px;
        justify-content: flex-end;
      }
      @include desktop {
        padding-top: 0;
        margin-top: 20px;
        justify-content: center;
      }
    }
    &-no-discount {
      color: var(--light-blue-gray);
      font-size: rem(12px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(14px);
    }
    &-amount {
      position: relative;
      &--cents {
        font-size: rem(27px);
        position: absolute;
        top: -7px;
        &-small-tile {
          font-size: rem(16px);
          font-style: normal;
          font-weight: 700;
          line-height: rem(20px);
          top: 0;
        }
      }
      &--small-tile {
        font-size: rem(32px);
        font-style: normal;
        font-weight: 700;
        line-height: rem(38px);
      }
    }
  }
  &__neon {
    &-wrapper {
      background-color: var(--cod-gray);
      background: url('../../assets/images/backgrounds/bl-bundle-price-bg.png');
      background-repeat: no-repeat;
      background-size: 65px;
      border-radius: 84.5px;
      height: 65px;
      width: 65px;
      position: absolute;
      left: 80%;
      top: 60%;
      @include mobile {
        left: 75%;
        top: -6%;
      }
      @include tablet-ipad-air-and-mini-portrait {
        left: 80%;
        top: 60%;
      }
      @include tablet-ipad-pro {
        left: 70%;
        top: -6%;
      }
      @include desktop {
        left: 75%;
        top: -6%;
      }
    }
    &-content {
      height: 87px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -10px;
      left: 5px;
    }
    &-text {
      font-size: rem(12px);
      font-weight: 700;
      line-height: rem(10px);
      text-align: center;
      width: 55px;
    }
  }
}
</style>
